export default __webpack_public_path__ + "static/media/author.36008335.svg";